// Simplified-Chinese strings for the taxonomy area. Keys are the exact English source strings.
export const taxonomy: Record<string, string> = {
  // Categories
  'Categories · Pinpoint': '分类 · Pinpoint',
  'Group notes by category. Rename, merge, or remove them here.': '按分类对笔记进行分组。可在此重命名、合并或移除。',
  'New category': '新建分类',
  'No categories yet. Add one above.': '暂无分类。请在上方添加。',
  'Delete the category “{name}”? Its notes will become uncategorised.': '删除分类“{name}”？其下笔记将变为未分类。',
  note: '条笔记',
  notes: '条笔记',
  'Merge into…': '合并到…',
  Merge: '合并',

  // Tags
  'Tags · Pinpoint': '标签 · Pinpoint',
  'Free-form labels applied to notes and videos. Rename, merge, or remove them here.':
    '应用于笔记和视频的自由标签。可在此重命名、合并或移除。',
  'New tag': '新建标签',
  'No tags yet. Tag a note or a video, or add one above.': '暂无标签。给笔记或视频打标签，或在上方添加。',
  'Delete the tag “{name}”? This removes it from all notes and videos.':
    '删除标签“{name}”？将从所有笔记和视频中移除。',
  use: '次使用',
  uses: '次使用',

  // Search page
  'Search · Pinpoint': '搜索 · Pinpoint',
  'Search notes & videos…': '搜索笔记和视频…',
  'No video matches.': '没有匹配的视频。',
  'No note matches.': '没有匹配的笔记。',

  // Search spotlight (⌘K)
  Untitled: '无标题',
  Recent: '最近搜索',
  'Start typing to search across your library…': '开始输入以搜索你的视频库…',
  'Searching…': '搜索中…',
  'No results for': '没有匹配结果：',
  navigate: '导航',
  open: '打开',
  close: '关闭',

  // Token picker
  'search…': '搜索…',
  '+ create “{name}”': '+ 创建“{name}”',
}
